var ko = require('knockout');

function ReportPage(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.reports = params.data;

  this.errorMessage = ko.observable();
  this.hasSelectedReport = ko.observable(false);

  this.reportsOptions = ko.observableArray();
  this.selectedReport = ko.observable();
  this.addReportsOptions();

  this.hotels = ko.observableArray();
  this.lecturers = ko.observableArray();

  this.showCourseId = ko.observable(false);
  this.showSequenceId = ko.observable(false);
  this.showEventId = ko.observable(false);
  this.showHotelPicker = ko.observable(false);
  this.showLecturerPicker = ko.observable(false);
  this.showDateFrom = ko.observable(false);
  this.showDateTo = ko.observable(false);

  this.baseUrl = ko.observable('');
  this.reportUrl = ko.observable();

  this.courseId = ko.observable();
  this.sequenceId = ko.observable();
  this.eventId = ko.observable();

  this.hotelOptions = ko.observableArray();
  this.selectedHotel = ko.observable();

  this.lecturerOptions = ko.observableArray();
  this.selectedLecturer = ko.observable();

  this.filterFromDate = ko.observable(this.getShortDate(new Date()));
  this.filterToDate = ko.observable(this.getShortDate(new Date()));

  this.courseId.subscribe(this.updateUrl.bind(this));
  this.sequenceId.subscribe(this.updateUrl.bind(this));
  this.eventId.subscribe(this.updateUrl.bind(this));
  this.selectedHotel.subscribe(this.updateUrl.bind(this));
  this.selectedLecturer.subscribe(this.updateUrl.bind(this));
  this.filterFromDate.subscribe(this.updateUrl.bind(this));
  this.filterToDate.subscribe(this.updateUrl.bind(this));
}

ReportPage.prototype.addReportsOptions = function() {
  var self = this;

  self.reportsOptions.push('Velg rapport');
  self.reports.forEach(function(report) {
    var reportName = report.ReportTypeName;
    if (reportName !== '' && self.reportsOptions.indexOf(reportName) === -1) {
      self.reportsOptions.push(reportName);
    }
  });
  self.selectedReport.subscribe(self.updateReportFields.bind(self));
};

ReportPage.prototype.updateReportFields = function() {
  var self = this;
  if (self.selectedReport() !== 'Velg rapport') {
    self.hasSelectedReport(true);

    var currentReport;
    self.reports.forEach(function(report) {
      if (report.ReportTypeName === self.selectedReport()) {
        currentReport = report;
      }
    });

    self.baseUrl(currentReport.ApiUrl);
    self.hotels(currentReport.HotelList);
    self.lecturers(currentReport.LecturerList);

    if (currentReport.HotelList !== null) {
      self.addHotelOptions(currentReport.HotelList);
    }
    if (currentReport.LecturerList !== null) {
      self.addLecturerOptions(currentReport.LecturerList);
    }
    if(currentReport.ReportTypeName === 'Utvidet KDB rapport'){
      self.showCourseId(currentReport.OptionalCourseId);
      self.showSequenceId(currentReport.OptionalSequenceId);
      self.showEventId(currentReport.OptionalEventId);
    }
    if(currentReport.ReportTypeName !== 'Utvidet KDB rapport'){
      self.showCourseId(currentReport.RequiresCourseId);
      self.showSequenceId(currentReport.RequiresSequenceId);
      self.showEventId(currentReport.RequiresEventId);
    }
    self.showHotelPicker(currentReport.RequiresHotelList);
    self.showLecturerPicker(currentReport.RequiresLecturerList);
    self.showDateFrom(currentReport.RequiresFromDate);
    self.showDateTo(currentReport.RequiresToDate);
  } else {
    self.hasSelectedReport(false);
  }
  self.baseUrl.subscribe(this.updateUrl.bind(this));
};

ReportPage.prototype.addHotelOptions = function(hotelList) {
  var self = this;
  self.hotelOptions.removeAll();
  self.hotelOptions.push('Velg hotell');
  hotelList.forEach(function(hotel) {
    self.hotelOptions.push(hotel.Name);
  });
};

ReportPage.prototype.addLecturerOptions = function(lecturerList) {
  var self = this;
  self.lecturerOptions.removeAll();
  self.lecturerOptions.push('Velg Kursleder');
  lecturerList.forEach(function(lecturer) {
    self.lecturerOptions.push(lecturer.Name);
  });
};

ReportPage.prototype.getShortDate = function(newDate) {
  var today = new Date(newDate);
  var formatted =
    (today.getDate().toString().length === 1
      ? '0' + today.getDate()
      : today.getDate()) +
    '.' +
    ((today.getMonth() + 1).toString().length === 1
      ? '0' + (today.getMonth() + 1)
      : today.getMonth() + 1) +
    '.' +
    today.getFullYear();
  return formatted;
};

ReportPage.prototype.formatDateToIsoDate = function(newdate) {
  var datesplit = newdate.split('.');
  var date = new Date(datesplit[2], datesplit[1] - 1, datesplit[0]);

  var formatted =
    date.getFullYear() +
    '-' +
    ((date.getMonth() + 1).toString().length === 1
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    '-' +
    (date.getDate().toString().length === 1
      ? '0' + date.getDate()
      : date.getDate());
  return formatted;
};

ReportPage.prototype.findLecturer = function() {
  var self = this;
  return self.lecturers().find(function(lecturer) {
    return lecturer.Name === self.selectedLecturer();
  });
};

ReportPage.prototype.findHotel = function() {
  var self = this;
  return self.hotels().find(function(hotel) {
    return hotel.Name === self.selectedHotel();
  });
};

ReportPage.prototype.updateUrl = function() {
  var self = this;

  var hotel = self.hotels() === null ? undefined : self.findHotel();
  var lecturer = self.lecturers() === null ? undefined : self.findLecturer();

  var qs = '?';
  qs += 'courseId=' + (self.courseId() || '');
  qs += '&sequenceId=' + (self.sequenceId() || '');
  qs += '&eventId=' + (self.eventId() || '');

  if (hotel && hotel !== '') {
    qs += '&hotel=' + (hotel.CoursePlacePk || '');
  }
  if (lecturer) {
    qs += '&lecturer=' + (lecturer.LecturerPK || '');
  }

  qs += '&fromDate=' + (self.formatDateToIsoDate(self.filterFromDate()) || '');
  qs += '&toDate=' + (self.formatDateToIsoDate(self.filterToDate()) || '');

  self.reportUrl(self.baseUrl() + qs);
};

module.exports = ReportPage;
